import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Footer, Header, MarkdownParser, Navbar } from "../components";
import { GenericMarkdownLoadingSkeleton } from "../components/LoadingSkeleton";
import ErrorPage from "./ErrorPage";
import customAxios from "../utils/customAxios";

import { styles } from "../styles";

export default function BeasiswaDetailPage() {
  const { slug } = useParams();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["scholarship", slug],

    queryFn: async () => {
      const response = await customAxios.get(`scholarships/${slug}`);

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderMarkdown = () => {
    if (isLoading) return <GenericMarkdownLoadingSkeleton />;
    if (!data) return null;

    const { description_en, description_id } = data;
    return (
      <MarkdownParser
        content={currentLanguage === "en" ? description_en : description_id}
      />
    );
  };

  const { title_en, title_id } = data || {};

  // 3. Provide a fallback title for the Header while loading
  const pageTitle = isLoading
    ? "..."
    : currentLanguage === "en"
      ? title_en
      : title_id;

  return (
    <>
      <Navbar />
      <Header title={pageTitle} />
      <main
        className={`${styles.paddingX} py-20 flex items-center flex-col min-h-[600px]`}
      >
        <section className="max-w-[1152px] w-full flex items-center flex-col space-y-20">
          {renderMarkdown()}
        </section>
      </main>
      <Footer />
    </>
  );
}
